import React from 'react';
import PropTypes from 'prop-types';
import {OrphanLocalizedLink} from 'components/ReactRouterDomLocalized';

import 'sass/ProfileLink.scss';
import {GENDER_COUPLE, GENDER_FEMALE, GENDER_MALE, GENDER_TRANSVESTITE} from '../constants/genders';

import paths from 'paths';

class ProfileLink extends React.Component {
    render() {
        let {user, __context, className, children, showGender = false, showRank = false, ...rest} = this.props;

        if (!user || !user.nick) return null;

        let classNames = ['profile-link'];
        if (showRank) classNames.push('show-rank');
        if (showGender) classNames.push('show-gender');
        if (className) classNames.push(className);

        let icon;
        if (showGender) {
            switch (user.gender) {
                case GENDER_MALE: icon = <span className="gender-icon male"/>; break;
                case GENDER_FEMALE: icon = <span className="gender-icon female"/>; break;
                case GENDER_COUPLE: icon = <span className="gender-icon couple"/>; break;
                case GENDER_TRANSVESTITE: icon = <span className="gender-icon transvestite"/>; break;
            }
        } else {
            if (showRank && user.gift_rank) icon = <span className={'ic-star-small ic-star' + user.gift_rank}/>;
        }

        let pathname = paths.profile.toPath({nick: user.nick}),
            classNamesJoined = classNames.join(' '),
            inside = children || user.nick;

        if (!icon) {
            return <OrphanLocalizedLink to={pathname} className={classNamesJoined} __context={__context} {...rest}>{inside}</OrphanLocalizedLink>
        }

        return (
            <span className={classNamesJoined}>
                {icon}
                <OrphanLocalizedLink to={pathname} __context={__context} {...rest}>{inside}</OrphanLocalizedLink>
            </span>
        );
    }
}

ProfileLink.propTypes = {
    user: PropTypes.object.isRequired,
    className: PropTypes.string,
    showGender: PropTypes.bool,
    showRank: PropTypes.bool
};

export default ProfileLink;


// WEBPACK FOOTER //
// ./src/components/ProfileLink.js